import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CellCalendarModalCombinedProps } from './types';

const usePresenter = (props: CellCalendarModalCombinedProps): CellCalendarModalCombinedProps => {
  const { onDateChanged, onSave, value } = props;
  const { t } = useTranslation();
  const [date, setDate] = useState<Date | undefined>(value);

  useEffect(() => {
    setDate(value);
  }, [value]);

  const onInputChanged = (newDate: Date) => {
    setDate(newDate);
    onDateChanged?.(newDate);
  };

  return {
    ...props,
    onInputChanged,
    date,
    timeInputLabel: t('datepicker.input_label'),
    cancelButton: {
      text: {
        value: t('datepicker.button_texts.cancel'),
      },
      onClick: () => {
        setDate(value);
        onSave?.(value);
      },
    },
    clearButton: {
      text: {
        value: t('datepicker.button_texts.clear'),
      },
      onClick: () => onSave?.(undefined),
    },
    doneButton: {
      text: {
        value: t('datepicker.button_texts.done'),
      },
      onClick: () => onSave?.(date),
    },
  };
};

export default usePresenter;
